export default __webpack_public_path__ + "static/media/people.73a337cc.svg";